define.alias("shared/components/shared/ui/checkbox-switch", "media/components/shared/ui/checkbox-switch");